__turbopack_context__.v({
  "fillAnimation": "LogoLoader-module__ggCbZW__fillAnimation",
  "svg": "LogoLoader-module__ggCbZW__svg",
  "wrapper": "LogoLoader-module__ggCbZW__wrapper",
});
